import * as React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@mui/material";
import TableFormInventario from "../components/TableFormInventario";
import SnackBar from "../components/SnackBarCustom";
import inventario from "../assets/inventario.png";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { styles } from "../theme/styles";

function StockProvider(props) {
  const { message, clearMessage } = props;

  return (
    <>
      <Grid style={styles.content2}>
        <Typography
          variant="h5"
          color="primary"
          height={"10%"}
          style={styles.title2}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-package"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="#00205b"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5" />
            <path d="M12 12l8 -4.5" />
            <path d="M12 12l0 9" />
            <path d="M12 12l-8 -4.5" />
            <path d="M16 5.25l-8 4.5" />
          </svg>
          &nbsp; Inventario
        </Typography>
        <br />
        <TableFormInventario />
        <img
          alt="Company Logo"
          src={inventario}
          style={styles.logoStock}
          variant="rounded"
        />
      </Grid>

      {message ? (
        <SnackBar
          message={message.text}
          variant={message.type}
          open={message ? true : false}
          onClose={clearMessage}
          time={3000}
        />
      ) : null}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    userData: state.users.data,
    message: state.config.message,
  };
};

const creators = {
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(StockProvider);
